var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"flex gap-4 my-4 font-light",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('tapped')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }